import { client } from './client'
import type { PackageFeed, SaveFeedRequest } from '@/types'

export const packageFeedsApi = {
  getAll: (projectId: string) =>
    client.get<PackageFeed[]>(`/projects/${projectId}/feeds`).then(r => r.data),
  create: (projectId: string, feed: SaveFeedRequest) =>
    client.post(`/projects/${projectId}/feeds`, feed),
  update: (projectId: string, feedId: string, feed: SaveFeedRequest) =>
    client.put(`/projects/${projectId}/feeds/${feedId}`, feed),
  delete: (projectId: string, feedId: string) =>
    client.delete(`/projects/${projectId}/feeds/${feedId}`),
}
